import { useQuery } from '@tanstack/react-query';
import { dateDimensionCustomPeriodService } from '../services/dateDimensionCustomPeriod.service';

export function useCustomPeriodVariants() {
  return useQuery({
    queryKey: ['custom-period-variants'],
    queryFn: () => dateDimensionCustomPeriodService.getVariants(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useCustomPeriods(variant: string | null) {
  return useQuery({
    queryKey: ['custom-periods', variant],
    queryFn: () => dateDimensionCustomPeriodService.find(variant),
    staleTime: 5 * 60 * 1000,
  });
}
